var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 58,
    viewBox: "0 0 96 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 57,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5409 28.7212C40.5409 22.8537 43.3687 17.66 47.7212 14.3846C44.7186 12.1252 40.998 10.7705 36.9507 10.7705C27.0371 10.7705 19 18.8076 19 28.7212C19 38.6348 27.0371 46.672 36.9507 46.672C40.998 46.672 44.7186 45.3161 47.7212 43.0579C43.3687 39.7813 40.5409 34.5887 40.5409 28.7212Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4916 10.7705C54.4443 10.7705 50.7237 12.1252 47.7212 14.3846C52.0736 17.66 54.9015 22.8537 54.9015 28.7212C54.9015 34.5887 52.0736 39.7813 47.7212 43.0579C50.7237 45.3173 54.4443 46.672 58.4916 46.672C68.4052 46.672 76.4423 38.6348 76.4423 28.7212C76.4423 18.8076 68.4052 10.7705 58.4916 10.7705Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7212 43.058C51.6867 43.058 54.9015 36.6393 54.9015 28.7214C54.9015 20.8035 51.6867 14.3848 47.7212 14.3848C43.7556 14.3848 40.5409 20.8035 40.5409 28.7214C40.5409 36.6393 43.7556 43.058 47.7212 43.058Z",
    fill: "#FF7300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.4423,
    height: 57.4423,
    fill: "white",
    transform: "translate(19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.159f2b285551cc6d2b9d81982e975bbd.svg";
export { ForwardRef as ReactComponent };